/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEuTaxonomyCompanyActivityDto } from '../models';
// @ts-ignore
import type { EuTaxonomyCompanyActivityCompaniesDto } from '../models';
// @ts-ignore
import type { EuTaxonomyCompanyActivityDetailDto } from '../models';
// @ts-ignore
import type { EuTaxonomyCompanyActivityDto } from '../models';
// @ts-ignore
import type { EuTaxonomyCompanyActivityYearsDto } from '../models';
// @ts-ignore
import type { UpdateEuTaxonomyCompanyActivityDto } from '../models';
/**
 * EuTaxonomyCompanyActivityApi - axios parameter creator
 * @export
 */
export const EuTaxonomyCompanyActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEuTaxonomyCompanyActivityDto} createEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity: async (createEuTaxonomyCompanyActivityDto: CreateEuTaxonomyCompanyActivityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEuTaxonomyCompanyActivityDto' is not null or undefined
            assertParamExists('euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity', 'createEuTaxonomyCompanyActivityDto', createEuTaxonomyCompanyActivityDto)
            const localVarPath = `/api/eu-taxonomy-company-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEuTaxonomyCompanyActivityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity: async (companyActivityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyActivityId' is not null or undefined
            assertParamExists('euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity', 'companyActivityId', companyActivityId)
            const localVarPath = `/api/eu-taxonomy-company-activity/{companyActivityId}/delete`
                .replace(`{${"companyActivityId"}}`, encodeURIComponent(String(companyActivityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyId] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities: async (companyId?: string, year?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/eu-taxonomy-company-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies: async (year?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/eu-taxonomy-company-activity/companies-basics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail: async (companyActivityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyActivityId' is not null or undefined
            assertParamExists('euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail', 'companyActivityId', companyActivityId)
            const localVarPath = `/api/eu-taxonomy-company-activity/{companyActivityId}/detail`
                .replace(`{${"companyActivityId"}}`, encodeURIComponent(String(companyActivityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/eu-taxonomy-company-activity/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {UpdateEuTaxonomyCompanyActivityDto} updateEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity: async (companyActivityId: string, updateEuTaxonomyCompanyActivityDto: UpdateEuTaxonomyCompanyActivityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyActivityId' is not null or undefined
            assertParamExists('euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity', 'companyActivityId', companyActivityId)
            // verify required parameter 'updateEuTaxonomyCompanyActivityDto' is not null or undefined
            assertParamExists('euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity', 'updateEuTaxonomyCompanyActivityDto', updateEuTaxonomyCompanyActivityDto)
            const localVarPath = `/api/eu-taxonomy-company-activity/{companyActivityId}/update`
                .replace(`{${"companyActivityId"}}`, encodeURIComponent(String(companyActivityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEuTaxonomyCompanyActivityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EuTaxonomyCompanyActivityApi - functional programming interface
 * @export
 */
export const EuTaxonomyCompanyActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EuTaxonomyCompanyActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEuTaxonomyCompanyActivityDto} createEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto: CreateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyId] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId?: string, year?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EuTaxonomyCompanyActivityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuTaxonomyCompanyActivityCompaniesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuTaxonomyCompanyActivityDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuTaxonomyCompanyActivityYearsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {UpdateEuTaxonomyCompanyActivityDto} updateEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId: string, updateEuTaxonomyCompanyActivityDto: UpdateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId, updateEuTaxonomyCompanyActivityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EuTaxonomyCompanyActivityApi - factory interface
 * @export
 */
export const EuTaxonomyCompanyActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EuTaxonomyCompanyActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEuTaxonomyCompanyActivityDto} createEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto: CreateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [companyId] 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId?: string, year?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EuTaxonomyCompanyActivityDto>> {
            return localVarFp.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year?: string, options?: RawAxiosRequestConfig): AxiosPromise<EuTaxonomyCompanyActivityCompaniesDto> {
            return localVarFp.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId: string, options?: RawAxiosRequestConfig): AxiosPromise<EuTaxonomyCompanyActivityDetailDto> {
            return localVarFp.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options?: RawAxiosRequestConfig): AxiosPromise<EuTaxonomyCompanyActivityYearsDto> {
            return localVarFp.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyActivityId 
         * @param {UpdateEuTaxonomyCompanyActivityDto} updateEuTaxonomyCompanyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId: string, updateEuTaxonomyCompanyActivityDto: UpdateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId, updateEuTaxonomyCompanyActivityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EuTaxonomyCompanyActivityApi - object-oriented interface
 * @export
 * @class EuTaxonomyCompanyActivityApi
 * @extends {BaseAPI}
 */
export class EuTaxonomyCompanyActivityApi extends BaseAPI {
    /**
     * 
     * @param {CreateEuTaxonomyCompanyActivityDto} createEuTaxonomyCompanyActivityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto: CreateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerCreateEuTaxonomyCompanyActivity(createEuTaxonomyCompanyActivityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyActivityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(companyActivityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [companyId] 
     * @param {string} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId?: string, year?: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(companyId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year?: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyActivityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityDetail(companyActivityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyActivityId 
     * @param {UpdateEuTaxonomyCompanyActivityDto} updateEuTaxonomyCompanyActivityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyCompanyActivityApi
     */
    public euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId: string, updateEuTaxonomyCompanyActivityDto: UpdateEuTaxonomyCompanyActivityDto, options?: RawAxiosRequestConfig) {
        return EuTaxonomyCompanyActivityApiFp(this.configuration).euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(companyActivityId, updateEuTaxonomyCompanyActivityDto, options).then((request) => request(this.axios, this.basePath));
    }
}

